import styled from '@emotion/styled'
import React, {Children, cloneElement, Component,} from 'react'
import {PALETTE} from '../../styles/paletteV3'
import getBBox from '../RetroReflectPhase/getBBox'







const INKBAR_HEIGHT = 2

const InkBar = styled('div')({
  background: PALETTE.GRAPE_700,
  bottom: 0,
  height: INKBAR_HEIGHT,
  left: 0,
  position: 'absolute',
  transformOrigin: 'left',
  transition: 'all 300ms',
  width: 1000
})

const TabsAndBar = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '24rem',
  position: 'relative',
  width: '100%'
})

const TabHeaders = styled('div')({
  display: 'flex',
  width: '100%'
})

class Tabs extends Component {constructor(...args) { super(...args); Tabs.prototype.__init.call(this);Tabs.prototype.__init2.call(this);Tabs.prototype.__init3.call(this);Tabs.prototype.__init4.call(this); }
  
  

  __init() {this.state = {
    transform: `scaleX(0)`
  }}
  __init2() {this.setChildRef = (c) => {
    if (c && c !== this.activeChildRef) {
      this.moveInkBar(this.parentRef, c)
    }
    this.activeChildRef = c
  }}

  __init3() {this.setParentRef = (c) => {
    if (c && c !== this.parentRef) {
      this.moveInkBar(c, this.activeChildRef)
    }
    this.parentRef = c
  }}

  __init4() {this.moveInkBar = (parent, child) => {
    const childBBox = child && getBBox(child)
    const parentBBox = parent && getBBox(parent)
    if (!childBBox || !parentBBox) return
    const left = childBBox.left - parentBBox.left
    this.setState({
      transform: `translate3d(${left}px, 0, 0)scaleX(${childBBox.width / 1000})`
    })
  }}

  render() {
    const {activeIdx, children, className} = this.props
    const {transform} = this.state
    const properChildren = Children.map(children, (child, idx) => {
      const isActive = idx === activeIdx
      return cloneElement(child , {
        isActive,
        ref: isActive ? this.setChildRef : null
      })
    })
    return (
      React.createElement(TabsAndBar, { className: className, ref: this.setParentRef,}
        , React.createElement(TabHeaders, null, properChildren)
        , React.createElement(InkBar, { style: {transform},} )
      )
    )
  }
}

export default Tabs
